import Splide from '@splidejs/splide';


// Home Page Slider
if(document.querySelector('.home-hero-slider')) {
	const homeHeroSlider = new Splide('.home-hero-slider', {
		type: 'fade',
		arrows: false,
		pagination: false,
		autoplay: true,
		rewind: true,
		interval: 5000,
		speed: 800,
		pauseOnHover: false,
	});
	homeHeroSlider.mount();
}

// Photo Bucket Slider
document.querySelectorAll('.photo-buckets-slider').forEach((el) => {
	const bucketSlider = new Splide(el, {
		type: 'loop',
		arrows: true,
		pagination: false,
		autoplay: false,
		focus: 'center',
		autoWidth: true,
		gap: '20px',
		updateOnMove: true,
		mediaQuery: 'min',
		breakpoints: {
		1201: {
				destroy: true,
			},
		}
	});
	bucketSlider.mount();
});


// Stats Slider
document.querySelectorAll('.stats-slider').forEach((el) => {
	const statsSlider = new Splide(el, {
		type: 'loop',
		arrows: true,
		pagination: false,
		autoplay: false,
		perPage: 2,
		gap: '20px',
		updateOnMove: true,
		mediaQuery: 'min',
		breakpoints: {
		768: {
				destroy: true,
			},
		}
	});
	statsSlider.mount();
});
